import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = 'https://aadhavacademy.com/api/session/attendance.php';

// ========================
// FETCH ALL SESSIONS
// ========================
export const fetchSessions = createAsyncThunk('attendance/fetchSessions', async () => {
  const res = await axios.get(API_URL, {
    params: { action: 'get_sessions' },
    headers: { Accept: 'application/json' },
  });
  return res.data;
});

// ========================
// FETCH STUDENTS FOR SESSION
// ========================
export const fetchStudents = createAsyncThunk('attendance/fetchStudents', async (session_id) => {
  const res = await axios.post(
    API_URL + '?action=get_students',
    { session_id },
    { headers: { Accept: 'application/json', 'Content-Type': 'application/json' } }
  );
  return res.data;
});

// ========================
// SAVE ATTENDANCE
// ========================
export const saveAttendance = createAsyncThunk(
  'attendance/saveAttendance',
  async ({ session_id, student_id, status }) => {
    const res = await axios.post(
      API_URL + '?action=save_attendance',
      { session_id, student_id, status },
      { headers: { Accept: 'application/json', 'Content-Type': 'application/json' } }
    );
    return res.data;
  }
);

// ========================
// SLICE
// ========================
const attendanceSlice = createSlice({
  name: 'attendance',
  initialState: {
    sessions: [],
    students: [],
    summary: { present_count: 0, total_students: 0, summary: '' },
    selectedSession: null,
  },
  reducers: {
    setSelectedSession: (state, action) => {
      state.selectedSession = action.payload;
    },
    updateStudentStatus: (state, action) => {
      const { id, status } = action.payload;
      const student = state.students.find((s) => s.id === id);
      if (student) student.status = status;
    },
    updateSummary: (state) => {
      const presentCount = state.students.filter((s) => s.status === 'Present').length;
      state.summary.present_count = presentCount;
      state.summary.total_students = state.students.length;
    },
  },
  extraReducers: (builder) => {
    builder
      // Sessions
      .addCase(fetchSessions.fulfilled, (state, action) => {
        state.sessions = action.payload;
      })

      // Students
      .addCase(fetchStudents.fulfilled, (state, action) => {
        state.students = action.payload.students || [];
        state.summary.present_count = action.payload.present_count || 0;
        state.summary.total_students = action.payload.total_students || state.students.length;
        state.summary.summary = action.payload.summary || '';
      });
  },
});

export const { setSelectedSession, updateStudentStatus, updateSummary } = attendanceSlice.actions;
export default attendanceSlice.reducer;
